import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function AutomaticUpdate() {
    return (
        <React.Fragment>
            <p>
                The Signiant App automatically checks for updates every 12 hours. To force an immediate update, edit the{' '}
                <code className="language-text">SigniantClient.json</code> file and delete the{' '}
                <code className="language-text">update-checked</code> line. The Signiant App then checks for an update
                after the next file transfer. A notification is displayed when the update is ready for installation.
            </p>
        </React.Fragment>
    );
}

AutomaticUpdate.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AutomaticUpdate);
